/* Zoom plein écran de la fiche (lot 6 « façon Loban » — docs/superpowers/specs/2026-10-03-moola-facon-loban.md, § 4.8).
   Ouvert par la loupe de la galerie, par window.MoolaTiroir (dialogue modal, focus piégé, Échap, verrou du défilement).
   Corrige les deux défauts relevés chez Loban : il S'OUVRE sur la photo courante de la galerie et, à la fermeture, REND la
   galerie à la photo regardée dans le zoom. Rail horizontal (une photo par écran), barre « ‹ n / N › », flèches du
   clavier ; double toucher ou double clic → ×2, le défilement natif sert à se déplacer dans la photo agrandie.
   Photos grand format chargées à la première ouverture seulement (data-src). Aucune bibliothèque.
   Appelé par le gabarit, donc AVANT moola-tiroir-base.js (layout) : il attend DOMContentLoaded (sinon window.MoolaTiroir
   n'existe pas encore et la loupe n'ouvre rien — mesuré au premier envoi). */
document.addEventListener('DOMContentLoaded', function () {
  var zoom = document.querySelector('[data-zoom]');
  var loupe = document.querySelector('[data-zoom-ouvrir]');
  var galerie = document.querySelector('[data-galerie]');
  if (!zoom || !loupe || !galerie || !window.MoolaTiroir) { return; }
  var rail = zoom.querySelector('[data-zoom-rail]');
  var vues = [].slice.call(zoom.querySelectorAll('[data-zoom-vue]'));
  var compteur = zoom.querySelector('[data-zoom-compteur]');
  var reduit = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (zoom.parentElement !== document.body) { document.body.appendChild(zoom); }

  // Photo courante gardée en mémoire : à la fermeture, le zoom est déjà caché (largeur 0) quand l'évènement arrive — le
  // relire alors rendait toujours la photo 1 (mesuré).
  var actuelle = 0;
  var index = function () { return rail.clientWidth ? Math.round(rail.scrollLeft / rail.clientWidth) : actuelle; };
  var majCompteur = function () { actuelle = index(); if (compteur) { compteur.textContent = (actuelle + 1) + ' / ' + vues.length; } rail.setAttribute('aria-label', 'Photo ' + (actuelle + 1) + ' sur ' + vues.length); };
  var aller = function (i, doux) {
    var n = Math.max(0, Math.min(vues.length - 1, i));
    vues.forEach(function (v) { v.classList.remove('est-agrandi'); });
    zoom.classList.remove('moola-zoom--agrandi');
    actuelle = n;
    rail.scrollTo({ left: n * rail.clientWidth, behavior: doux && !reduit.matches ? 'smooth' : 'instant' });
  };
  var t = 0;
  rail.addEventListener('scroll', function () { cancelAnimationFrame(t); t = requestAnimationFrame(majCompteur); }, { passive: true });

  loupe.addEventListener('click', function () {
    var depart = Number(galerie.dataset.index || 0);
    vues.forEach(function (v) { var img = v.querySelector('img[data-src]'); if (img) { img.src = img.getAttribute('data-src'); img.removeAttribute('data-src'); } });
    window.MoolaTiroir.ouvrir(zoom, { declencheur: loupe, duree: 0, focus: '[data-tiroir-fermer]' });
    aller(depart, false);
    majCompteur();
  });
  // Fermeture (Échap, croix, retour arrière) : la galerie montre la photo regardée.
  zoom.addEventListener('moola:tiroir-ferme', function () {
    var n = actuelle;
    vues.forEach(function (v) { v.classList.remove('est-agrandi'); });
    zoom.classList.remove('moola-zoom--agrandi');
    galerie.scrollTo({ left: n * galerie.clientWidth, behavior: 'instant' });
    galerie.dataset.index = String(n);
  });

  var prec = zoom.querySelector('[data-zoom-prec]');
  var suiv = zoom.querySelector('[data-zoom-suiv]');
  if (prec) { prec.addEventListener('click', function () { aller(index() - 1, true); }); }
  if (suiv) { suiv.addEventListener('click', function () { aller(index() + 1, true); }); }
  document.addEventListener('keydown', function (e) {
    if (!window.MoolaTiroir.ouvert(zoom)) { return; }
    if (e.key === 'ArrowRight') { e.preventDefault(); aller(index() + 1, true); }
    else if (e.key === 'ArrowLeft') { e.preventDefault(); aller(index() - 1, true); }
  });

  // ×2 au double toucher / double clic, centré sur le point visé ; un second double geste revient à ×1.
  var basculer = function (vue, x, y) {
    var img = vue.querySelector('img'); if (!img) { return; }
    var q = img.getBoundingClientRect();
    var fx = q.width ? (x - q.left) / q.width : 0.5, fy = q.height ? (y - q.top) / q.height : 0.5;
    var agrandi = !vue.classList.contains('est-agrandi');
    vue.classList.toggle('est-agrandi', agrandi);
    zoom.classList.toggle('moola-zoom--agrandi', agrandi);
    if (agrandi) {
      requestAnimationFrame(function () {
        var r = img.getBoundingClientRect();
        vue.scrollLeft = Math.max(0, fx * r.width - vue.clientWidth / 2);
        vue.scrollTop = Math.max(0, fy * r.height - vue.clientHeight / 2);
      });
    }
  };
  // Au doigt, Chrome émet AUSSI un dblclick ~100 ms après le second toucher : il annulait aussitôt la bascule faite par
  // pointerup (×2 puis ×1, mesuré au CDP le 04/10). Un dblclick qui suit de près une bascule tactile est ignoré.
  var dernier = { t: 0, x: 0, y: 0 }, basculeTactile = 0;
  vues.forEach(function (vue) {
    vue.addEventListener('dblclick', function (e) { if (Date.now() - basculeTactile < 600) { return; } basculer(vue, e.clientX, e.clientY); });
    vue.addEventListener('pointerup', function (e) {
      if (e.pointerType !== 'touch') { return; }
      var maintenant = Date.now();
      if (maintenant - dernier.t < 320 && Math.abs(e.clientX - dernier.x) < 30 && Math.abs(e.clientY - dernier.y) < 30) { basculeTactile = maintenant; basculer(vue, e.clientX, e.clientY); dernier.t = 0; return; }
      dernier = { t: maintenant, x: e.clientX, y: e.clientY };
    });
  });
});
